import { useEffect, useRef } from "react";
import { CategoryScale, Chart, Filler, LineController, LineElement, LinearScale, PointElement, Tooltip } from "chart.js";
import { fmtDate } from "../../format";

Chart.register(LineController, LineElement, PointElement, LinearScale, CategoryScale, Tooltip, Filler);

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const label = (iso: string) => `${MONTHS[Number(iso.slice(5, 7)) - 1]}'${iso.slice(2, 4)}`;

export function WeightChart({ weights }: { weights: { date: string; lb: number }[] }) {
  const ref = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (!ref.current) return;
    const values = weights.map((w) => w.lb);
    const min = 2 * Math.floor((Math.min(...values) - 3) / 2), max = 2 * Math.ceil((Math.max(...values) + 3) / 2);
    const chart = new Chart(ref.current, {
      type: "line",
      data: {
        labels: weights.map((w) => label(w.date)),
        datasets: [{
          label: "Recorded", data: values, borderColor: "#2BBCAA", backgroundColor: "rgba(43,188,170,0.09)",
          borderWidth: 2, pointRadius: 5, pointBackgroundColor: "#2BBCAA", tension: 0.35, fill: true,
        }],
      },
      options: {
        responsive: true, maintainAspectRatio: false, animation: false,
        plugins: {
          legend: { display: false },
          tooltip: { callbacks: { title: (items) => fmtDate(weights[items[0].dataIndex].date), label: (c) => `${Number(c.parsed.y).toFixed(1)} lb` } },
        },
        scales: {
          x: { grid: { color: "rgba(0,0,0,0.06)" }, ticks: { color: "#8BA8B8", font: { size: 10 }, maxRotation: 0 } },
          y: { min, max, grid: { color: "rgba(0,0,0,0.06)" }, ticks: { color: "#8BA8B8", font: { size: 10 }, stepSize: 2, callback: (v) => `${v} lb` } },
        },
      },
    });
    return () => chart.destroy();
  }, [weights]);

  return <div style={{ position: "relative", width: "100%", height: 110 }}><canvas ref={ref} /></div>;
}
